import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "actionCost",
    serviceName: "unitadmin",
    query: gql`
      query actionCost($action_ids: [String]) {
        actionCost(action_ids: $action_ids) {
          data {
            price
            is_active
          }
        }
      }
    `,
  },
  create: {
    name: "createOrUpdateActionCost",
    serviceName: "labadmin",
    query: gql`
      mutation createOrUpdateActionCost(
        $action_id: String!
        $price: String!
        $is_active: Int
      ) {
        createOrUpdateActionCost(
          action_id: $action_id
          price: $price
          is_active: $is_active
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
